import request from '@/utils/request'
// 用户中心 - 登录密码修改
export function resetPassword (data) {
  return request({
    url: 'auth/password',
    method: 'post',
    params: data
  })
}

export function login (data) {
  return request({
    url: 'auth/login',
    method: 'post',
    params: data
  })
}

export function register (data) {
  return request({
    url: 'auth/register',
    method: 'post',
    params: data
  })
}

export function logout (data) {
  return request({
    url: 'auth/logout',
    method: 'post',
    params: data
  })
}

export function getVcode (data) {
  return request({
    url: 'auth/vcode',
    method: 'post',
    params: data
  })
}

export function getVcodeReg (data) {
  return request({
    url: 'auth/vcodeReg',
    method: 'post',
    params: data
  })
}

export function reset (data) {
  return request({
    url: 'auth/reset',
    method: 'post',
    params: data
  })
}